<template>
<!--SEARCH-->
  <Modal v-if="popupTriggers.searchesButtonTrigger" :TogglePopup="() => TogglePopup('searchesButtonTrigger')">
    <div class="home-search-results">
      <header class="home-search-results-header">
        <div>
          <span>QUICK SEARCH</span>
          <h1>Search results</h1>
        </div>
        <div v-if="refreshingData" class="home-search-results-refresh">
          <span class="spinner-border" aria-hidden="true"></span>
          Refreshing
        </div>
      </header>
      <section class="home-search-results-section">
        <div class="home-search-results-heading"><h2>Users <span>({{ searchUsers.length }})</span></h2></div>
        <div v-if="searchUsers.length === 0" class="home-search-results-empty">No users found.</div>
        <div v-else class="home-search-results-table-wrap">
    <table class="table table-hover home-search-results-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Cellnumber</th>
          <th>Country</th>
          <th>Email</th>
          <th>Created</th>
          <th>Last Group</th>
          <th>Places</th>
          <th>Created Groups</th>
          <th>All Groups</th>
          <th>Devices</th>
          <th>App</th>
          <th>Phone</th>
          <th>Licenses</th>
          <th>Recent License</th>
          <th>Notes</th>
          <th>Details</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="users in searchUsers" :key="users">
          <td>{{ users.name }}</td>
          <td>{{ users.cellnumber }}</td>
          <td>{{ users.country }}</td>
          <td>{{ users.email }}</td>
          <td>{{ users.created_date }}</td>
          <td>{{ users.last_joined_date }}</td>
          <td>{{ users.places }}</td>
          <td>{{ users.created_hunts }}</td>
          <td>{{ users.all_hunts }}</td>
          <td>{{ users.deviceslength }}</td>
          <td>{{ users.app }}</td>
          <td>{{ users.phone }}</td>
          <td>{{ users.licenseslength }}</td>
          <td>{{ users.last_license_date }}</td>
          <td>{{ users.noteslength }}</td>
          <td><svg v-on:click="usersModal(users)" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg></td>
        </tr>
      </tbody>
    </table>
        </div>
      </section>
      <section class="home-search-results-section">
        <div class="home-search-results-heading"><h2>SIMs <span>({{ searchSims.length }})</span></h2></div>
        <div v-if="searchSims.length === 0" class="home-search-results-empty">No SIMs found.</div>
        <div v-else class="home-search-results-table-wrap">
    <table class="table table-hover home-search-results-table">
      <thead>
        <tr>
          <th>Number</th>
          <th>Valid Until</th>
          <th>Deleted</th>
          <th>Status</th>
          <th>Operator</th>
          <th>IMEI</th>
          <th>Brand</th>
          <th>Pricing Model</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sims in searchSims" :key="sims">
          <td>{{ sims.phoneNumber }}</td>
          <td>{{ sims.validUntil }}</td>
          <td>{{ sims.deleted }}</td>
          <td>{{ sims.status }}</td>
          <td>{{ sims.operator }}</td>
          <td>{{ sims.imei }}</td>
          <td>{{ sims.brand }}</td>
          <td>{{ sims.pricingModel }}</td>
          <td>{{ sims.notes }}</td>
        </tr>
      </tbody>
    </table>
        </div>
      </section>
    </div>
  </Modal>
<!--USER-->
  <Modal v-if="false && popupTriggers.usersButtonTrigger" :TogglePopup="() => TogglePopup('usersButtonTrigger')">
    <div>
      <p style="font-weight: bold; font-size: 14px">General Info</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">Name</th>
            <th class="bold">Cellnumber</th>
            <th class="bold">Email</th>
            <th class="bold">Created</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>{{ user.name }}</th>
            <th>{{ user.cellnumber }}</th>
            <th>{{ user.email }}</th>
            <th>{{ user.created_date }}</th>
          </tr>
        </tbody>
      </table>

      <p style="font-weight: bold; font-size: 14px">Teams Info</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">Team name</th>
            <th class="bold">Role</th>
            <th class="bold">Team owner</th>
            <th class="bold">Team owner number</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in user.teamsinfo" :key="user">
            <th>{{ user.teamName }}</th>
            <th>{{ user.teamRole }}</th>
            <th>{{ user.teamOwner }}</th>
            <th>{{ user.teamOwnerNumber }}</th>
          </tr>
        </tbody>
      </table>

      <p style="font-weight: bold; font-size: 14px">Group Info</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">Group</th>
            <th class="bold">Info</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th class="bold">Groups created</th>
            <th scope="row">
              {{ user.created_hunts }}
            </th>
          </tr>
          <tr>
            <th class="bold">Groups joined</th>
            <th scope="row">
              {{ user.all_hunts }}
            </th>
          </tr>
          <tr>
            <th class="bold">Last group</th>
            <th scope="row">
              <div v-if="user.last_joined_date == ''">None</div>
              <div v-else>
                {{ user.last_joined_date }}
              </div>
            </th>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-between">
        <p style="font-weight: bold; font-size: 14px">Licenses</p>
        <button class="btn btn-outline-dark btn-rounded" v-on:click="toggleUserLicense()">Add License</button>
      </div>
      
      <div v-if="togglenewlicense">
        <p style="font-size: 10px; margin-bottom: -2px">Date</p>
        <input v-model="userLicenseDate" type="date" class="form-control" style="width:60%" />
        <p style="font-size: 10px; margin-bottom: -2px">Comment</p>
        <input id="newLicenseComment" type="text" class="form-control" style="width:60%" />
        <button v-on:click="submitSingleLicense(user)" class="btn btn-outline-dark btn-rounded mt-2">Add License</button>
      </div>
      
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">#</th>
            <th class="bold">Comment</th>
            <th class="bold">Creator</th>
            <th class="bold">Product</th>
            <th class="bold">Created</th>
            <th class="bold">Valid until</th>
          </tr>
        </thead>
        <tbody v-if="!togglelicenses && user.licenses != null">
          <tr>
            <th>1</th>
            <th>{{ user.licenses[0].comment }}</th>
            <th>{{ user.licenses[0].creator }}</th>
            <th>{{ user.licenses[0].product }}</th>
            <th>{{ new Date(user.licenses[0].created).getFullYear() }}-{{("0" + (new Date(user.licenses[0].created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.licenses[0].created).getDate()).slice(-2)}}</th>
            <th>{{ new Date(user.licenses[0].validuntil).getFullYear() }}-{{("0" + (new Date(user.licenses[0].validuntil).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.licenses[0].validuntil).getDate()).slice(-2)}}</th>
          </tr>
        </tbody>
        <tbody v-else-if="togglelicenses">
          <tr v-for="(user, index) in user.licenses" :key="user">
            <th scope="row">{{ index + 1 }}</th>
            <th scope="row">{{ user.comment }}</th>
            <th scope="row">{{ user.creator }}</th>
            <th scope="row">{{ user.product }}</th>
            <th scope="row">{{ new Date(user.created).getFullYear() }}-{{("0" + (new Date(user.created).getMonth() + 1)).slice(-2)}}-{{ ("0" + new Date(user.created).getDate()).slice(-2) }}</th>
            <th scope="row">{{ new Date(user.validuntil).getFullYear() }}-{{("0" + (new Date(user.validuntil).getMonth() + 1)).slice(-2)}}-{{ ("0" + new Date(user.validuntil).getDate()).slice(-2) }}</th>
          </tr>
        </tbody>
      </table>

      <div class="row justify-content-center" v-if="!togglelicenses">
        <svg v-on:click="toggleLicenses()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-expand" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z" /></svg>
      </div>
      <div class="row justify-content-center" v-else-if="togglelicenses">
        <svg v-on:click="toggleLicenses()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-collapse" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z" /></svg>
      </div>


      <p style="font-weight: bold; font-size: 14px">Devices</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">#</th>
            <th class="bold">App Language</th>
            <th class="bold">App Version</th>
            <th class="bold">Created</th>
            <th class="bold">Email</th>
            <th class="bold">Manufacturer</th>
            <th class="bold">Model</th>
            <th class="bold">Name</th>
            <th class="bold">OS</th>
            <th class="bold">OS Version</th>
          </tr>
        </thead>
        <tbody v-if="!toggledevices && user.devices != null">
          <tr>
            <th>1</th>
            <th>{{ user.devices[0].applanguage }}</th>
            <th>{{ user.devices[0].appversion }}</th>
            <th>{{ new Date(user.devices[0].created).getFullYear() }}-{{("0" + (new Date(user.devices[0].created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.devices[0].created).getDate()).slice(-2)}}</th>
            <th>{{ user.devices[0].email }}</th>
            <th>{{ user.devices[0].manufacturer }}</th>
            <th>{{ user.devices[0].model }}</th>
            <th>{{ user.devices[0].name }}</th>
            <th>{{ user.devices[0].opsys }}</th>
            <th>{{ user.devices[0].opsysversion }}</th>
          </tr>
        </tbody>
        <tbody v-else-if="toggledevices">
          <tr v-for="(user, index) in user.devices" :key="user">
            <th scope="row">{{ index + 1 }}</th>
            <th scope="row">{{ user.applanguage }}</th>
            <th scope="row">{{ user.appversion }}</th>
            <th scope="row">{{ new Date(user.created).getFullYear() }}-{{("0" + (new Date(user.created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.created).getDate()).slice(-2)}}</th>
            <th scope="row">{{ user.email }}</th>
            <th scope="row">{{ user.manufacturer }}</th>
            <th scope="row">{{ user.model }}</th>
            <th scope="row">{{ user.name }}</th>
            <th scope="row">{{ user.opsys }}</th>
            <th scope="row">{{ user.opsysversion }}</th>
          </tr>
        </tbody>
      </table>

      <div class="row justify-content-center" v-if="!toggledevices">
        <svg v-on:click="toggleDevices()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-expand" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z" /></svg>
      </div>
      <div class="row justify-content-center" v-else-if="toggledevices">
        <svg v-on:click="toggleDevices()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-collapse" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z" /></svg>
      </div>

      <p style="font-weight: bold; font-size: 14px">Notes</p>
      <table class="table table-hover">
        <thead>
          <tr>
            <th class="bold">#</th>
            <th class="bold">Created</th>
            <th class="bold">Comment</th>
          </tr>
        </thead>
        <tbody v-if="!togglenotes && user.notes.length != 0">
          <tr>
            <th>1</th>
            <th>{{ new Date(user.notes[0].created).getFullYear() }}-{{("0" + (new Date(user.notes[0].created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(user.notes[0].created).getDate()).slice(-2)}}</th>
            <th v-if="user.notes[0].data.text != null">{{ user.notes[0].data.text }}</th>
            <th scope="row" v-else-if="user.notes[0].data.text == null && user.notes[0].name == 'huntloc_login'">Huntloc Login</th>
            <th scope="row" v-else-if="user.notes[0].data.text == null && user.notes[0].name == 'liveteam_login'">Liveteam Login</th>
            <th scope="row" v-else></th>
          </tr>
        </tbody>
        <tbody v-else-if="togglenotes">
          <tr v-for="(notes, index) in user.notes" :key="notes">
            <th scope="row">{{ index + 1 }}</th>
            <th>{{ new Date(notes.created).getFullYear() }}-{{("0" + (new Date(notes.created).getMonth() + 1)).slice(-2)}}-{{("0" + new Date(notes.created).getDate()).slice(-2)}}</th>
            <th scope="row" v-if="notes.data.text != null">{{ notes.data.text }}</th>
            <th scope="row" v-else-if="notes.data.text == null && notes.name == 'huntloc_login'">Huntloc Login</th>
            <th scope="row" v-else-if="notes.data.text == null && notes.name == 'liveteam_login'">Liveteam Login</th>
            <th scope="row" v-else></th>
          </tr>
        </tbody>
      </table>

      <div class="row justify-content-center" v-if="!togglenotes">
        <svg v-on:click="toggleNotes()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-expand" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z" /></svg>
      </div>
      <div class="row justify-content-center" v-else-if="togglenotes">
        <svg v-on:click="toggleNotes()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrows-collapse" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z" /></svg>
      </div>

      <p style="font-weight: bold; font-size: 14px">Add note</p>
      <textarea id="userNoteInput" style="height: 100px" class="form-control" />
      <button type="button" class="btn btn-outline-dark btn-rounded" data-mdb-ripple-color="dark" v-on:click="addNotes(user)">Add Note</button>

            <div class="justify-content-between d-flex"><span><p style="font-weight: bold; font-size: 14px">Portal Authentication</p></span><span><button class="btn btn-outline-dark btn-rounded" v-on:click="toPortal()">Portal</button></span></div>

      <input type="text" class="form-control" placeholder="" v-model="portalPIN"/>
      <button type="button" class="btn btn-outline-dark btn-rounded" data-mdb-ripple-color="dark" v-on:click="loginPortal(user)">Login</button>
    </div>
  </Modal>

  <UserDetailsModal
    :visible="popupTriggers.usersButtonTrigger"
    :toggle-popup="() => TogglePopup('usersButtonTrigger')"
    :user="user"
  />

<!--MAIN-->
  <div class="col bg-light" style="width: 100%" v-if="!store.state.usersLoaded && !store.state.localUsers">
    <div class="lds-ring" style="margin-left: 50%; margin-top: 20%">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <!--SEARCHESMODAL SHOWER-->
  <div v-else class="col bg-light analytics-view">
    <header class="analytics-header">
      <h1>Analytics</h1>
      <div class="analytics-header-updated">Updated: {{ formatLastUpdated() }} <span v-if="refreshingData" class="analytics-header-loading"><span class="spinner-border" aria-hidden="true"></span></span></div>
    </header>
    <section class="analytics-filters-card">
    <div class="analytics-filter-row">
      <span class="analytics-filter-label">Brand</span>
      <select v-model="countryAnalyticsAppFilter" class="form-select form-select-sm analytics-filter-select">
        <option value="">All users</option>
        <option value="Huntloc">Huntloc</option>
        <option value="Doglo">Doglo</option>
        <option value="Liveteam">Liveteam</option>
      </select>
      <span class="analytics-filter-label">Created</span>
      <input
        v-model="countryAnalyticsCreatedFrom"
        type="date"
        class="form-control form-control-sm analytics-date-filter"
      />
      <span class="analytics-filter-label">to</span>
      <input
        v-model="countryAnalyticsCreatedTo"
        type="date"
        class="form-control form-control-sm analytics-date-filter"
      />
    </div>
    <div class="analytics-columns-row">
      <span class="analytics-filter-label">Columns</span>
      <label
        v-for="column in countryAnalyticsColumnDefinitions"
        :key="column.key"
        class="analytics-column-toggle"
      >
        <input
          :checked="analyticsVisibleColumns[column.key] !== false"
          type="checkbox"
          class="form-check-input mt-0"
          @change="setCountryAnalyticsColumnVisibility(column.key, $event.target.checked)"
        />
        <span>{{ column.label }}</span>
      </label>
    </div>
    </section>
    <div class="analytics-table-wrap">
    <table class="table table-hover analytics-table">
      <thead>
        <tr>
          <th>
            <div class="analytics-header-cell">
              <button type="button" class="analytics-sort-button" @click="toggleCountryAnalyticsSort('country')">Country{{ getCountryAnalyticsSortIndicator('country') }}</button>
            </div>
          </th>
          <th v-for="column in visibleCountryAnalyticsColumns" :key="column.key">
            <div class="analytics-header-cell">
              <button type="button" class="analytics-sort-button" @click="toggleCountryAnalyticsSort(column.sortKey)">
                {{ column.label }}{{ getCountryAnalyticsSortIndicator(column.sortKey) }}
              </button>
              <span
                v-if="column.tooltip"
                class="analytics-info-icon"
                :title="column.tooltip"
                :aria-label="column.tooltip"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                </svg>
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in topCountryAnalyticsRows"
          :key="row.country"
          :class="getCountryAnalyticsRowClass(row)"
        >
          <td>{{ row.country }}</td>
          <td v-for="column in visibleCountryAnalyticsColumns" :key="column.key">{{ formatCountryAnalyticsCell(row, column) }}</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import * as $ from "alga-js"
import { ref } from "vue"
import Modal from "@/components/Modal.vue"
import UserDetailsModal from "@/components/UserDetailsModal.vue"
import { inject } from 'vue'
import { mapState } from 'vuex'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import { API_ENDPOINTS } from '@/config/api'
import { getLicenseValidUntilTimestamp, normalizeAdminUsers } from '@/utils/userUtils'
import { getCountryNameFromPhoneNumber } from '@/utils/countryUtils'
import { findTeamBySimLinkValue, normalizeSimTeamLinkValue, LEGACY_SIM_PRICING_MODELS } from '@/utils/simTeamLink'

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000


export default {
  name: "HomeTable",
  components: {
    Modal,
    UserDetailsModal,
  },
  setup() {
    const store = inject('store')
    const popupTriggers = ref({
      searchesButtonTrigger: false,
      usersButtonTrigger: false,
      simsButtonTrigger: false,
    });

    const TogglePopup = (trigger) => {
      popupTriggers.value[trigger] = !popupTriggers.value[trigger];
    };
    return {
      Modal,
      popupTriggers,
      TogglePopup,
      store
    };
  },
  mounted() {
    if(!this.store.state.usersLoaded){
      this.$store.dispatch('loadUsers')
    }
  },
  data() {
    return {
      loadingSearch: false,
      togglenotes: false,
      togglelicenses: false,
      toggledevices: false,
      togglenewlicense: false,
      title: "Info",
      searchInput: "",
      users: [],
      sims: [],
      team: [],
      searchEntries: [],
      searchUsers: [],
      searchSims: [],
      user: {},
      sim: {},
      utoday: 0,
      uyesterday: 0,
      uweek: 0,
      umonth: 0,
      esttoday: 0,
      estyesterday: 0,
      estweek: 0,
      estmonth: 0,
      ltvtoday: 0,
      ltvyesterday: 0,
      ltvweek: 0,
      ltvmonth: 0,
      littoday: 0,
      lityesterday: 0,
      litweek: 0,
      litmonth: 0,
      fintoday: 0,
      finyesterday: 0,
      finweek: 0,
      finmonth: 0,
      exptoday: 0,
      expyesterday: 0,
      expweek: 0,
      expmonth: 0,
      estexptoday: 0,
      estexpyesterday: 0,
      estexpweek: 0,
      estexpmonth: 0,
      ltvexptoday: 0,
      ltvexpyesterday: 0,
      ltvexpweek: 0,
      ltvexpmonth: 0,
      litexptoday: 0,
      litexpyesterday: 0,
      litexpweek: 0,
      litexpmonth: 0,
      finexptoday: 0,
      finexpyesterday: 0,
      finexpweek: 0,
      finexpmonth: 0,
      gtoday: 0,
      gyesterday: 0,
      gweek: 0,
      gmonth: 0,
      estgtoday: 0,
      estgyesterday: 0,
      estgweek: 0,
      estgmonth: 0,
      ltvgtoday: 0,
      ltvgyesterday: 0,
      ltvgweek: 0,
      ltvgmonth: 0,
      litgtoday: 0,
      litgyesterday: 0,
      litgweek: 0,
      litgmonth: 0,
      fingtoday: 0,
      fingyesterday: 0,
      fingweek: 0,
      fingmonth: 0,
      sumtoday: 0,
      sumyest: 0,
      sumweek: 0,
      summonth: 0,
      expsumtoday: 0,
      expsumyest: 0,
      expsumweek: 0,
      expsummonth: 0,
      gsumtoday: 0,
      gsumyest: 0,
      gsumweek: 0,
      gsummonth: 0,
      countryAnalyticsAppFilter: "",
      countryAnalyticsCreatedFrom: "",
      countryAnalyticsCreatedTo: "",
      countryAnalyticsSortKey: "",
      countryAnalyticsSortDirection: "",
      analyticsVisibleColumns: {
        totalUsers: true,
        activeUsers: true,
        validLicenseUsers: true,
        paidLicenseUsers: true,
        teamCount: true,
        licensedTeamCount: true,
        linkedTrackersCount: true,
        inTeamsUsers: true,
        inLicensedTeamsUsers: true,
        joinedLast30Days: true,
        joinedHuntLast30Days: true,
      },
      portalPIN: "",
      loaded: false,
      last_updated: 0,
      refreshingData: true,
      tempInput: ""
    };
  },
  computed: {
    tableColumns() {
      return this.columns
    },
    countryAnalyticsColumnDefinitions() {
      return [
        { key: "totalUsers", label: "Users", sortKey: "totalUsers" },
        { key: "activeUsers", label: "Active users", sortKey: "activeUsers", percentBaseKey: "totalUsers", tooltip: "Percentage is calculated from the Users value." },
        { key: "validLicenseUsers", label: "Valid license", sortKey: "validLicenseUsers", percentBaseKey: "activeUsers", tooltip: "Includes trial licenses. Percentage is calculated from the Active users value." },
        { key: "paidLicenseUsers", label: "Paid license", sortKey: "paidLicenseUsers", percentBaseKey: "activeUsers", tooltip: "Estimated from valid licenses lasting more than 30 calendar days from license creation (account creation if unavailable). Percentage is calculated from the Active users value." },
        { key: "teamCount", label: "Teams", sortKey: "teamCount" },
        { key: "licensedTeamCount", label: "Licensed teams", sortKey: "licensedTeamCount" },
        { key: "linkedTrackersCount", label: "Linked trackers in teams", sortKey: "linkedTrackersCount" },
        { key: "inTeamsUsers", label: "Users in teams", sortKey: "inTeamsUsers" },
        { key: "inLicensedTeamsUsers", label: "Users in licensed teams", sortKey: "inLicensedTeamsUsers", percentBaseKey: "paidLicenseUsers", tooltip: "Percentage is calculated from the Paid license value." },
        { key: "joinedLast30Days", label: "Joined last 30 days", sortKey: "joinedLast30Days" },
        { key: "joinedHuntLast30Days", label: "Joined hunt last 30 days", sortKey: "joinedHuntLast30Days" },
      ]
    },
    visibleCountryAnalyticsColumns() {
      return this.countryAnalyticsColumnDefinitions.filter((column) => this.analyticsVisibleColumns[column.key] !== false)
    },
    normalizedAnalyticsUsers() {
      return this.normalizeUsers(this.users)
    },
    teamAnalyticsByCountry() {
      return this.buildTeamAnalyticsByCountry(this.team, this.sims)
    },
    teamMembershipByPhone() {
      const memberships = new Map()
      const teams = this.normalizeArray(this.team)

      for (let teamIndex = 0; teamIndex < teams.length; teamIndex += 1) {
        const team = teams[teamIndex]
        const hasLicensedTeam = this.hasLicensedTeam(team)
        const permissions = this.normalizeArray(team?.permissions)

        for (let permissionIndex = 0; permissionIndex < permissions.length; permissionIndex += 1) {
          const phoneNumber = permissions[permissionIndex]?.user?.phoneNumber
          if (typeof phoneNumber !== "string" || phoneNumber.trim().length === 0) continue

          if (!memberships.has(phoneNumber)) {
            memberships.set(phoneNumber, {
              inTeams: false,
              inLicensedTeams: false,
            })
          }

          const membership = memberships.get(phoneNumber)
          membership.inTeams = true
          if (hasLicensedTeam) membership.inLicensedTeams = true
        }
      }

      return memberships
    },
    countryAnalyticsRows() {
      const teamMembershipByPhone = this.teamMembershipByPhone
      return this.buildCountryAnalyticsRows(
        this.normalizedAnalyticsUsers,
        this.countryAnalyticsAppFilter,
        this.countryAnalyticsCreatedFrom,
        this.countryAnalyticsCreatedTo,
        teamMembershipByPhone,
        this.teamAnalyticsByCountry
      )
    },
    topCountryAnalyticsRows() {
      if (this.countryAnalyticsRows.length === 0) return []

      const [totalRow, ...countryRows] = this.countryAnalyticsRows
      return [totalRow, ...this.sortCountryAnalyticsRows(countryRows)]
    },
    computed: mapState(['users']),
  },
  created() {
    this.getLocalData()
    this.getData()
  },
  methods: {
    formatLastUpdated() {
      const value = String(this.last_updated || '').trim()
      if (!value) return '-'
      if (/\d{1,2}\.\d{1,2}\.\d{4}/.test(value)) return value

      return `${new Date().toLocaleDateString('et-EE')} ${value}`
    },
    normalizeUsers(value) {
      return normalizeAdminUsers(this.normalizeArray(value))
    },
    filterUsersByApp(users, appFilter = "") {
      const normalizedUsers = this.normalizeArray(users)
      if (typeof appFilter !== "string" || appFilter.trim().length === 0) {
        return normalizedUsers
      }

      return normalizedUsers.filter((user) => user.app === appFilter)
    },
    parseDateFilterValue(value, endOfDay = false) {
      if (typeof value !== "string" || value.trim().length === 0) return null

      const parts = value.split("-").map((part) => Number(part))
      if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) return null

      const [year, month, day] = parts
      const date = new Date(year, month - 1, day)
      if (endOfDay) {
        date.setHours(23, 59, 59, 999)
      } else {
        date.setHours(0, 0, 0, 0)
      }

      return date.getTime()
    },
    parseDateLikeValue(value, endOfDay = false) {
      if (value == null) return null

      if (typeof value === "number" && Number.isFinite(value)) {
        const date = new Date(value)
        if (endOfDay) {
          date.setHours(23, 59, 59, 999)
        } else {
          date.setHours(0, 0, 0, 0)
        }
        return date.getTime()
      }

      if (typeof value === "string") {
        const trimmedValue = value.trim()
        if (trimmedValue.length === 0) return null

        if (/^\d+$/.test(trimmedValue)) {
          const numericValue = Number(trimmedValue)
          if (!Number.isFinite(numericValue)) return null

          const date = new Date(numericValue)
          if (endOfDay) {
            date.setHours(23, 59, 59, 999)
          } else {
            date.setHours(0, 0, 0, 0)
          }
          return date.getTime()
        }

        return this.parseDateFilterValue(trimmedValue, endOfDay)
      }

      return null
    },
    filterUsersByCreatedRange(users, createdFrom = "", createdTo = "") {
      const createdFromTimestamp = this.parseDateFilterValue(createdFrom, false)
      const createdToTimestamp = this.parseDateFilterValue(createdTo, true)

      if (!Number.isFinite(createdFromTimestamp) && !Number.isFinite(createdToTimestamp)) {
        return users
      }

      return users.filter((user) => {
        const createdTimestamp = Number(user?.created)
        if (!Number.isFinite(createdTimestamp)) return false
        if (Number.isFinite(createdFromTimestamp) && createdTimestamp < createdFromTimestamp) return false
        if (Number.isFinite(createdToTimestamp) && createdTimestamp > createdToTimestamp) return false
        return true
      })
    },
    getLatestLicenseTimestamp(user) {
      if (Number.isFinite(user?.last_license)) {
        return user.last_license
      }

      const licenses = this.normalizeArray(user?.licenses)
      if (licenses.length === 0) return null

      let latestValidUntil = null
      for (let index = 0; index < licenses.length; index += 1) {
        const currentValidUntil = Number(licenses[index]?.validuntil)
        if (!Number.isFinite(currentValidUntil)) continue
        if (latestValidUntil == null || currentValidUntil > latestValidUntil) {
          latestValidUntil = currentValidUntil
        }
      }

      return latestValidUntil
    },
    hasValidLicense(user, nowTimestamp = Date.now()) {
      const latestLicenseTimestamp = this.getLatestLicenseTimestamp(user)
      return Number.isFinite(latestLicenseTimestamp) && latestLicenseTimestamp >= nowTimestamp
    },
    toStartOfDayTimestamp(timestamp) {
      if (!Number.isFinite(timestamp)) return null

      const date = new Date(timestamp)
      date.setHours(0, 0, 0, 0)

      return date.getTime()
    },
    hasPaidLicense(user, nowTimestamp = Date.now()) {
      const licenses = this.normalizeArray(user?.licenses)
      const candidates = licenses.length > 0
        ? licenses
        : [{ validuntil: user?.last_license }]

      return candidates.some((license) => {
        const validUntil = getLicenseValidUntilTimestamp(license)
        if (!Number.isFinite(validUntil) || validUntil < nowTimestamp) return false

        // A trial can be granted after signup. Prefer the license's own creation date.
        const created = license?.created ?? user?.created
        if (created == null || created === '') return false
        const createdTimestamp = Number(created)
        if (!Number.isFinite(createdTimestamp) || createdTimestamp <= 0) return false

        const createdDate = new Date(createdTimestamp)
        const expiryDate = new Date(validUntil)
        // Compare calendar dates so daylight-saving changes cannot add an extra hour.
        const createdDay = Date.UTC(createdDate.getFullYear(), createdDate.getMonth(), createdDate.getDate())
        const expiryDay = Date.UTC(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate())
        return expiryDay - createdDay > THIRTY_DAYS_MS
      })
    },
    hasLicensedTeam(team, nowTimestamp = Date.now()) {
      const teamValidUntilDayTimestamp = this.toStartOfDayTimestamp(Number(team?.validUntil))
      const currentDayTimestamp = this.toStartOfDayTimestamp(nowTimestamp)

      if (!Number.isFinite(teamValidUntilDayTimestamp) || !Number.isFinite(currentDayTimestamp)) {
        return false
      }

      return teamValidUntilDayTimestamp >= currentDayTimestamp
    },
    hasValidSim(sim, nowTimestamp = Date.now()) {
      const simValidUntilDayTimestamp = this.parseDateLikeValue(sim?.validUntil, true)
      const currentDayTimestamp = this.toStartOfDayTimestamp(nowTimestamp)

      if (!Number.isFinite(simValidUntilDayTimestamp) || !Number.isFinite(currentDayTimestamp)) {
        return false
      }

      return simValidUntilDayTimestamp >= currentDayTimestamp
    },
    isWithinLast30Days(timestamp, nowTimestamp = Date.now()) {
      if (!Number.isFinite(timestamp)) return false
      return timestamp >= nowTimestamp - THIRTY_DAYS_MS && timestamp <= nowTimestamp
    },
    isWithinLast365Days(timestamp, nowTimestamp = Date.now()) {
      if (!Number.isFinite(timestamp)) return false
      return timestamp >= nowTimestamp - (365 * 24 * 60 * 60 * 1000) && timestamp <= nowTimestamp
    },
    createCountryAnalyticsRow(country) {
      return {
        country,
        totalUsers: 0,
        activeUsers: 0,
        validLicenseUsers: 0,
        paidLicenseUsers: 0,
        teamCount: 0,
        licensedTeamCount: 0,
        linkedTrackersCount: 0,
        inTeamsUsers: 0,
        inLicensedTeamsUsers: 0,
        joinedLast30Days: 0,
        joinedHuntLast30Days: 0,
      }
    },
    addUserToCountryAnalyticsRow(row, user, nowTimestamp, teamMembershipByPhone = this.teamMembershipByPhone) {
      row.totalUsers += 1
      const membership = teamMembershipByPhone.get(user?.cellnumber)

      if (this.isWithinLast365Days(Number(user.last_joined), nowTimestamp)) row.activeUsers += 1
      if (this.hasValidLicense(user, nowTimestamp)) row.validLicenseUsers += 1
      if (this.hasPaidLicense(user, nowTimestamp)) row.paidLicenseUsers += 1
      if (membership?.inTeams) row.inTeamsUsers += 1
      if (membership?.inLicensedTeams) row.inLicensedTeamsUsers += 1
      if (this.isWithinLast30Days(Number(user.created), nowTimestamp)) row.joinedLast30Days += 1
      if (this.isWithinLast30Days(Number(user.last_joined), nowTimestamp)) row.joinedHuntLast30Days += 1
    },
    getTeamCountry(team) {
      const ownerPhoneNumber = String(team?.phoneNumber || "").trim()
      if (ownerPhoneNumber.length === 0) return ""
      return getCountryNameFromPhoneNumber(ownerPhoneNumber)
    },
    createCountryTeamMetrics() {
      return {
        teamCount: 0,
        licensedTeamCount: 0,
        linkedTrackersCount: 0,
      }
    },
    addTeamMetricsToCountryRow(row, metrics) {
      if (row == null || metrics == null) return

      row.teamCount += Number(metrics.teamCount) || 0
      row.licensedTeamCount += Number(metrics.licensedTeamCount) || 0
      row.linkedTrackersCount += Number(metrics.linkedTrackersCount) || 0
    },
    buildTeamAnalyticsByCountry(teams = this.team, sims = this.sims) {
      const normalizedTeams = this.normalizeArray(teams)
      const normalizedSims = this.normalizeArray(sims)
      const nowTimestamp = Date.now()
      const rowsByCountry = new Map()
      const totals = this.createCountryTeamMetrics()
      const teamCountryByLinkValue = new Map()

      for (let index = 0; index < normalizedTeams.length; index += 1) {
        const team = normalizedTeams[index]
        const country = this.getTeamCountry(team)
        const metrics = this.createCountryTeamMetrics()
        metrics.teamCount = 1
        if (this.hasLicensedTeam(team)) metrics.licensedTeamCount = 1

        totals.teamCount += metrics.teamCount
        totals.licensedTeamCount += metrics.licensedTeamCount

        if (country.length > 0) {
          if (!rowsByCountry.has(country)) {
            rowsByCountry.set(country, this.createCountryTeamMetrics())
          }
          this.addTeamMetricsToCountryRow(rowsByCountry.get(country), metrics)
        }

        const teamUuid = String(team?.uuid || "").trim()
        const teamName = String(team?.teamName || team?.name || "").trim()

        if (teamUuid.length > 0) teamCountryByLinkValue.set(teamUuid, country)
        if (teamName.length > 0) teamCountryByLinkValue.set(teamName, country)
      }

      for (let index = 0; index < normalizedSims.length; index += 1) {
        const sim = normalizedSims[index]
        const normalizedLinkValue = normalizeSimTeamLinkValue(sim?.pricingModel)

        if (
          normalizedLinkValue.length === 0 ||
          LEGACY_SIM_PRICING_MODELS.includes(normalizedLinkValue) ||
          !this.hasValidSim(sim, nowTimestamp)
        ) {
          continue
        }

        let linkedCountry = teamCountryByLinkValue.get(normalizedLinkValue) || ""

        if (linkedCountry.length === 0) {
          const linkedTeam = findTeamBySimLinkValue(normalizedLinkValue, normalizedTeams)
          if (!linkedTeam) continue
          linkedCountry = this.getTeamCountry(linkedTeam)
        }

        totals.linkedTrackersCount += 1

        if (linkedCountry.length === 0) continue

        if (!rowsByCountry.has(linkedCountry)) {
          rowsByCountry.set(linkedCountry, this.createCountryTeamMetrics())
        }
        rowsByCountry.get(linkedCountry).linkedTrackersCount += 1
      }

      return {
        rowsByCountry,
        totals,
      }
    },
    subtractCountryAnalyticsRows(totalRow, usedRows) {
      const otherRow = { ...totalRow, country: "Other countries" }

      for (let index = 0; index < usedRows.length; index += 1) {
        otherRow.totalUsers -= usedRows[index].totalUsers
        otherRow.activeUsers -= usedRows[index].activeUsers
        otherRow.validLicenseUsers -= usedRows[index].validLicenseUsers
        otherRow.paidLicenseUsers -= usedRows[index].paidLicenseUsers
        otherRow.teamCount -= usedRows[index].teamCount
        otherRow.licensedTeamCount -= usedRows[index].licensedTeamCount
        otherRow.linkedTrackersCount -= usedRows[index].linkedTrackersCount
        otherRow.joinedLast30Days -= usedRows[index].joinedLast30Days
        otherRow.joinedHuntLast30Days -= usedRows[index].joinedHuntLast30Days
      }

      return otherRow
    },
    buildCountryAnalyticsRows(users, appFilter = "", createdFrom = "", createdTo = "", teamMembershipByPhone = this.teamMembershipByPhone, teamAnalyticsByCountry = this.teamAnalyticsByCountry) {
      const normalizedUsers = this.filterUsersByCreatedRange(
        this.filterUsersByApp(users, appFilter),
        createdFrom,
        createdTo
      )
      const nowTimestamp = Date.now()
      const analyticsByCountry = new Map()
      const totalRow = this.createCountryAnalyticsRow("Total")

      for (let index = 0; index < normalizedUsers.length; index += 1) {
        const user = normalizedUsers[index]
        this.addUserToCountryAnalyticsRow(totalRow, user, nowTimestamp, teamMembershipByPhone)

        const country = typeof user?.country === "string" ? user.country.trim() : ""
        if (country.length === 0) continue

        if (!analyticsByCountry.has(country)) {
          analyticsByCountry.set(country, this.createCountryAnalyticsRow(country))
        }

        const row = analyticsByCountry.get(country)
        this.addUserToCountryAnalyticsRow(row, user, nowTimestamp, teamMembershipByPhone)
      }

      this.addTeamMetricsToCountryRow(totalRow, teamAnalyticsByCountry?.totals)

      if (teamAnalyticsByCountry?.rowsByCountry instanceof Map) {
        for (const [country, metrics] of teamAnalyticsByCountry.rowsByCountry.entries()) {
          if (!analyticsByCountry.has(country)) {
            analyticsByCountry.set(country, this.createCountryAnalyticsRow(country))
          }
          this.addTeamMetricsToCountryRow(analyticsByCountry.get(country), metrics)
        }
      }

      return [totalRow, ...Array.from(analyticsByCountry.values())]
    },
    getDefaultCountryAnalyticsSortDirection(sortKey) {
      return sortKey === "country" ? "asc" : "desc"
    },
    getCountryAnalyticsSortIndicator(sortKey) {
      if (this.countryAnalyticsSortKey !== sortKey || this.countryAnalyticsSortDirection.length === 0) {
        return ""
      }

      return this.countryAnalyticsSortDirection === "asc" ? " ^" : " v"
    },
    toggleCountryAnalyticsSort(sortKey) {
      if (this.countryAnalyticsSortKey !== sortKey) {
        this.countryAnalyticsSortKey = sortKey
        this.countryAnalyticsSortDirection = this.getDefaultCountryAnalyticsSortDirection(sortKey)
        return
      }

      if (this.countryAnalyticsSortDirection === "asc") {
        this.countryAnalyticsSortDirection = "desc"
        return
      }

      if (this.countryAnalyticsSortDirection === "desc") {
        this.countryAnalyticsSortKey = ""
        this.countryAnalyticsSortDirection = ""
        return
      }

      this.countryAnalyticsSortDirection = this.getDefaultCountryAnalyticsSortDirection(sortKey)
    },
    setCountryAnalyticsColumnVisibility(columnKey, isVisible) {
      this.analyticsVisibleColumns[columnKey] = isVisible

      if (!isVisible && this.countryAnalyticsSortKey === columnKey) {
        this.countryAnalyticsSortKey = ""
        this.countryAnalyticsSortDirection = ""
      }
    },
    sortCountryAnalyticsRows(rows) {
      const sortedRows = [...rows]
      const sortKey = this.countryAnalyticsSortKey
      const sortDirection = this.countryAnalyticsSortDirection

      if (typeof sortKey !== "string" || sortKey.length === 0 || typeof sortDirection !== "string" || sortDirection.length === 0) {
        return sortedRows.sort((leftCountry, rightCountry) => {
          if (rightCountry.paidLicenseUsers !== leftCountry.paidLicenseUsers) {
            return rightCountry.paidLicenseUsers - leftCountry.paidLicenseUsers
          }

          if (rightCountry.totalUsers !== leftCountry.totalUsers) {
            return rightCountry.totalUsers - leftCountry.totalUsers
          }

          return leftCountry.country.localeCompare(rightCountry.country, "et", { sensitivity: "base" })
        })
      }

      const sortMultiplier = sortDirection === "asc" ? 1 : -1
      return sortedRows.sort((leftCountry, rightCountry) => {
        if (sortKey === "country") {
          const result = leftCountry.country.localeCompare(rightCountry.country, "et", { sensitivity: "base" })
          if (result !== 0) return result * sortMultiplier
        } else {
          const leftValue = Number(leftCountry[sortKey]) || 0
          const rightValue = Number(rightCountry[sortKey]) || 0

          if (leftValue !== rightValue) {
            return (leftValue - rightValue) * sortMultiplier
          }
        }

        return leftCountry.country.localeCompare(rightCountry.country, "et", { sensitivity: "base" })
      })
    },
    formatPercentage(value, total) {
      const safeTotal = Number(total)
      const safeValue = Number(value)

      if (!Number.isFinite(safeTotal) || safeTotal <= 0 || !Number.isFinite(safeValue)) {
        return "0%"
      }

      const percentage = (safeValue / safeTotal) * 100
      const roundedPercentage = Math.round(percentage * 10) / 10

      if (Number.isInteger(roundedPercentage)) {
        return `${roundedPercentage.toFixed(0)}%`
      }

      return `${roundedPercentage.toFixed(1)}%`
    },
    formatMetricWithPercent(value, total) {
      const safeValue = Number.isFinite(Number(value)) ? Number(value) : 0
      return `${safeValue} (${this.formatPercentage(safeValue, total)})`
    },
    formatCountryAnalyticsCell(row, column) {
      const value = Number.isFinite(Number(row?.[column.key])) ? Number(row[column.key]) : 0
      if (column?.percentBaseKey) {
        const baseValue = Number.isFinite(Number(row?.[column.percentBaseKey])) ? Number(row[column.percentBaseKey]) : 0
        return this.formatMetricWithPercent(value, baseValue)
      }

      return value
    },
    getCountryAnalyticsRowClass(row) {
      if (row?.country === "Total") return "analytics-row-total"
      return ""
    },
    //GET REQUESTS_______________________________________________________________________________________
    saveData() {
      localStorage.setItem('utoday', this.utoday)
      localStorage.setItem('uyesterday', this.uyesterday)
      localStorage.setItem('uweek', this.uweek)
      localStorage.setItem('umonth', this.umonth)
      localStorage.setItem('esttoday', this.esttoday)
      localStorage.setItem('estyesterday', this.estyesterday)
      localStorage.setItem('estweek', this.estweek)
      localStorage.setItem('estmonth', this.estmonth)
      localStorage.setItem('ltvtoday', this.ltvtoday)
      localStorage.setItem('ltvyesterday', this.ltvyesterday)
      localStorage.setItem('ltvweek', this.ltvweek)
      localStorage.setItem('ltvmonth', this.ltvmonth)
      localStorage.setItem('littoday', this.littoday)
      localStorage.setItem('lityesterday', this.lityesterday)
      localStorage.setItem('litweek', this.litweek)
      localStorage.setItem('litmonth', this.litmonth)
      localStorage.setItem('fintoday', this.fintoday)
      localStorage.setItem('finyesterday', this.finyesterday)
      localStorage.setItem('finweek', this.finweek)
      localStorage.setItem('finmonth', this.finmonth)
      localStorage.setItem('exptoday', this.exptoday)
      localStorage.setItem('expyesterday', this.expyesterday)
      localStorage.setItem('expweek', this.expweek)
      localStorage.setItem('expmonth', this.expmonth)
      localStorage.setItem('estexptoday', this.estexptoday)
      localStorage.setItem('estexpyesterday', this.estexpyesterday)
      localStorage.setItem('estexpweek', this.estexpweek)
      localStorage.setItem('estexpmonth', this.estexpmonth)
      localStorage.setItem('ltvexptoday', this.ltvexptoday)
      localStorage.setItem('ltvexpyesterday', this.ltvexpyesterday)
      localStorage.setItem('ltvexpweek', this.ltvexpweek)
      localStorage.setItem('ltvexpmonth', this.ltvexpmonth)
      localStorage.setItem('litexptoday', this.litexptoday)
      localStorage.setItem('litexpyesterday', this.litexpyesterday)
      localStorage.setItem('litexpweek', this.litexpweek)
      localStorage.setItem('litexpmonth', this.litexpmonth)
      localStorage.setItem('finexptoday', this.finexptoday)
      localStorage.setItem('finexpyesterday', this.finexpyesterday)
      localStorage.setItem('finexpweek', this.finexpweek)
      localStorage.setItem('finexpmonth', this.finexpmonth)
      localStorage.setItem('gtoday', this.gtoday)
      localStorage.setItem('gyesterday', this.gyesterday)
      localStorage.setItem('gweek', this.gweek)
      localStorage.setItem('gmonth', this.gmonth)
      localStorage.setItem('estgtoday', this.estgtoday)
      localStorage.setItem('estgyesterday', this.estgyesterday)
      localStorage.setItem('estgweek', this.estgweek)
      localStorage.setItem('estgmonth', this.estgmonth)
      localStorage.setItem('ltvgtoday', this.ltvgtoday)
      localStorage.setItem('ltvgyesterday', this.ltvgyesterday)
      localStorage.setItem('ltvgweek', this.ltvgweek)
      localStorage.setItem('ltvgmonth', this.ltvgmonth)
      localStorage.setItem('litgtoday', this.litgtoday)
      localStorage.setItem('litgyesterday', this.litgyesterday)
      localStorage.setItem('litgweek', this.litgweek)
      localStorage.setItem('litgmonth', this.litgmonth)
      localStorage.setItem('fingtoday', this.fingtoday)
      localStorage.setItem('fingyesterday', this.fingyesterday)
      localStorage.setItem('fingweek', this.fingweek)
      localStorage.setItem('fingmonth', this.fingmonth)
      localStorage.setItem('sumtoday', this.sumtoday)
      localStorage.setItem('sumyest', this.sumyest)
      localStorage.setItem('sumweek', this.sumweek)
      localStorage.setItem('summonth', this.summonth)
      localStorage.setItem('expsumtoday', this.expsumtoday)
      localStorage.setItem('expsumyest', this.expsumyest)
      localStorage.setItem('expsumweek', this.expsumweek)
      localStorage.setItem('expsummonth', this.expsummonth)
      localStorage.setItem('gsumtoday', this.gsumtoday)
      localStorage.setItem('gsumyest', this.gsumyest)
      localStorage.setItem('gsumweek', this.gsumweek)
      localStorage.setItem('gsummonth', this.gsummonth)
    },
    getLocalData() {
      this.utoday= localStorage.getItem('utoday')
      this.uyesterday= localStorage.getItem('uyesterday')
      this.uweek= localStorage.getItem('uweek')
      this.umonth= localStorage.getItem('umonth')
      this.esttoday= localStorage.getItem('esttoday')
      this.estyesterday= localStorage.getItem('estyesterday')
      this.estweek= localStorage.getItem('estweek')
      this.estmonth= localStorage.getItem('estmonth')
      this.ltvtoday= localStorage.getItem('ltvtoday')
      this.ltvyesterday= localStorage.getItem('ltvyesterday')
      this.ltvweek= localStorage.getItem('ltvweek')
      this.ltvmonth= localStorage.getItem('ltvmonth')
      this.littoday= localStorage.getItem('littoday')
      this.lityesterday= localStorage.getItem('lityesterday')
      this.litweek= localStorage.getItem('litweek')
      this.litmonth= localStorage.getItem('litmonth')
      this.fintoday= localStorage.getItem('fintoday')
      this.finyesterday= localStorage.getItem('finyesterday')
      this.finweek= localStorage.getItem('finweek')
      this.finmonth= localStorage.getItem('finmonth')
      this.exptoday= localStorage.getItem('exptoday')
      this.expyesterday= localStorage.getItem('expyesterday')
      this.expweek= localStorage.getItem('expweek')
      this.expmonth= localStorage.getItem('expmonth')
      this.estexptoday= localStorage.getItem('estexptoday')
      this.estexpyesterday= localStorage.getItem('estexpyesterday')
      this.estexpweek= localStorage.getItem('estexpweek')
      this.estexpmonth= localStorage.getItem('estexpmonth')
      this.ltvexptoday= localStorage.getItem('ltvexptoday')
      this.ltvexpyesterday= localStorage.getItem('ltvexpyesterday')
      this.ltvexpweek= localStorage.getItem('ltvexpweek')
      this.ltvexpmonth= localStorage.getItem('ltvexpmonth')
      this.litexptoday= localStorage.getItem('litexptoday')
      this.litexpyesterday= localStorage.getItem('litexpyesterday')
      this.litexpweek= localStorage.getItem('litexpweek')
      this.litexpmonth= localStorage.getItem('litexpmonth')
      this.finexptoday= localStorage.getItem('finexptoday')
      this.finexpyesterday= localStorage.getItem('finexpyesterday')
      this.finexpweek= localStorage.getItem('finexpweek')
      this.finexpmonth= localStorage.getItem('finexpmonth')
      this.gtoday= localStorage.getItem('gtoday')
      this.gyesterday= localStorage.getItem('gyesterday')
      this.gweek= localStorage.getItem('gweek')
      this.gmonth= localStorage.getItem('gmonth')
      this.estgtoday= localStorage.getItem('estgtoday')
      this.estgyesterday= localStorage.getItem('estgyesterday')
      this.estgweek= localStorage.getItem('estgweek')
      this.estgmonth= localStorage.getItem('estgmonth')
      this.ltvgtoday= localStorage.getItem('ltvgtoday')
      this.ltvgyesterday= localStorage.getItem('ltvgyesterday')
      this.ltvgweek= localStorage.getItem('ltvgweek')
      this.ltvgmonth= localStorage.getItem('ltvgmonth')
      this.litgtoday= localStorage.getItem('litgtoday')
      this.litgyesterday= localStorage.getItem('litgyesterday')
      this.litgweek= localStorage.getItem('litgweek')
      this.litgmonth= localStorage.getItem('litgmonth')
      this.fingtoday= localStorage.getItem('fingtoday')
      this.fingyesterday= localStorage.getItem('fingyesterday')
      this.fingweek= localStorage.getItem('fingweek')
      this.fingmonth= localStorage.getItem('fingmonth')
      this.last_updated = localStorage.getItem('last_updated')
      this.sumtoday= localStorage.getItem('sumtoday')
      this.sumyest= localStorage.getItem('sumyest')
      this.sumweek= localStorage.getItem('sumweek')
      this.summonth= localStorage.getItem('summonth')
      this.expsumtoday= localStorage.getItem('expsumtoday')
      this.expsumyest= localStorage.getItem('expsumyest')
      this.expsumweek= localStorage.getItem('expsumweek')
      this.expsummonth= localStorage.getItem('expsummonth')
      this.gsumtoday= localStorage.getItem('gsumtoday')
      this.gsumyest= localStorage.getItem('gsumyest')
      this.gsumweek= localStorage.getItem('gsumweek')
      this.gsummonth= localStorage.getItem('gsummonth')
      let storage = []
        for(let i = 0; i < 2002; i++){
          let user = JSON.parse(localStorage.getItem(i))
          storage.push(user)
        }
      this.users = this.normalizeUsers(storage.filter(Boolean))
      let simsAPI = API_ENDPOINTS.TIW_API + "/sim/all"
      axios.get(simsAPI).then((res) => {
        this.sims = this.normalizeArray(res.data)
      })
      let teamsAPI = API_ENDPOINTS.TIW_API + "/team/list_all"
        axios.get(teamsAPI).then((data) => {
          this.team = this.prepareTeams(data.data)
        })
    },
    async getData() {
      let now = new Date()
      let yyyy = now.getFullYear()
      let mm = now.getMonth()
      let dd = now.getDate()
      let date = new Date(yyyy, mm, dd)
      let daystart = date.getTime()
      let dayend = daystart + 86399999
      let yesterdayend = daystart - 1
      let yesterdaystart = daystart - 86399999
      let weekdaystart = daystart - 604800000
      let monthdaystart = daystart - 2629800000
      if (this.store.state.usersLoaded) {
        this.users = this.normalizeUsers(this.store.state.users)
        this.utoday = 0
        this.uyesterday = 0
        this.uweek = 0
        this.umonth =0
        this.esttoday =0
        this.estyesterday =0
        this.estweek =0
        this.estmonth =0
        this.ltvtoday =0
        this.ltvyesterday =0
        this.ltvweek =0
        this.ltvmonth =0
        this.littoday =0
        this.lityesterday =0
        this.litweek =0
        this.litmonth =0
        this.fintoday =0
        this.finyesterday =0
        this.finweek =0
        this.finmonth =0
        this.exptoday =0
        this.expyesterday =0
        this.expweek =0
        this.expmonth =0
        this.estexptoday =0
        this.estexpyesterday =0
        this.estexpweek = 0
        this.estexpmonth =0
        this.ltvexptoday =0
        this.ltvexpyesterday =0
        this.ltvexpweek =0
        this.ltvexpmonth =0
        this.litexptoday =0
        this.litexpyesterday =0
        this.litexpweek =0
        this.litexpmonth =0
        this.finexptoday =0
        this.finexpyesterday =0
        this.finexpweek =0
        this.finexpmonth =0
        this.gtoday =0
        this.gyesterday =0
        this.gweek =0
        this.gmonth =0
        this.estgtoday =0
        this.estgyesterday =0
        this.estgweek =0
        this.estgmonth =0
        this.ltvgtoday =0
        this.ltvgyesterday =0
        this.ltvgweek =0
        this.ltvgmonth =0
        this.litgtoday =0
        this.litgyesterday =0
        this.litgweek =0
        this.litgmonth =0
        this.fingtoday =0
        this.fingyesterday =0
        this.fingweek =0
        this.fingmonth =0
        this.sumtoday= 0
        this.sumyest= 0
        this.sumweek=0
        this.summonth= 0
        this.expsumtoday= 0
        this.expsumyest= 0
        this.expsumweek=0
        this.expsummonth= 0
        this.gsumtoday= 0
        this.gsumyest= 0
        this.gsumweek=0
        this.gsummonth= 0
        for (let i = 0; i < this.users.length; i++) {
          //Created accounts today
          if (this.users[i].created >= daystart && this.users[i].created <= dayend) {
            this.utoday++
            if (this.users[i].cellnumber != null) {
              if (this.users[i].cellnumber.substring(0, 4) == "+372"){ this.esttoday++; this.sumtoday++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+371"){ this.ltvtoday++; this.sumtoday++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+370"){ this.littoday++; this.sumtoday++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+358"){ this.fintoday++; this.sumtoday++;}
            }
          }
          //Created accounts yesterday
          if (this.users[i].created >= yesterdaystart && this.users[i].created <= yesterdayend) {
            this.uyesterday++
            if (this.users[i].cellnumber != null) {
              if (this.users[i].cellnumber.substring(0, 4) == "+372"){ this.estyesterday++; this.sumyest++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+371"){this.ltvyesterday++; this.sumyest++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+370"){ this.lityesterday++; this.sumyest++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+358"){ this.finyesterday++; this.sumyest++;}
            }
          }
          //Created account this week
          if (this.users[i].created >= weekdaystart && this.users[i].created <= dayend) {
            this.uweek++
            if (this.users[i].cellnumber != null) {
              if (this.users[i].cellnumber.substring(0, 4) == "+372"){ this.estweek++; this.sumweek++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+371"){ this.ltvweek++; this.sumweek++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+370"){ this.litweek++; this.sumweek++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+358"){ this.finweek++; this.sumweek++;}
            }
          }
          //Created accounts this month
          if (this.users[i].created >= monthdaystart && this.users[i].created <= dayend) {
            this.umonth++
            if (this.users[i].cellnumber != null) {
              if (this.users[i].cellnumber.substring(0, 4) == "+372"){ this.estmonth++; this.summonth++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+371"){ this.ltvmonth++; this.summonth++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+370"){ this.litmonth++; this.summonth++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+358"){ this.finmonth++; this.summonth++;}
            }
          }
          //Expired licenses today
          if (this.users[i].licenses != null) {
            if (this.users[i].licenses[0].validuntil >= daystart && this.users[i].licenses[0].validuntil <= dayend) {
              this.exptoday++
              if (this.users[i].cellnumber != null) {
                if (this.users[i].cellnumber.substring(0, 4) == "+372") {this.estexptoday++; this.expsumtoday++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+371") {this.ltvexptoday++; this.expsumtoday++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+370") {this.litexptoday++; this.expsumtoday++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+358") {this.finexptoday++; this.expsumtoday++;}
              }
            }
            //Expired licenses yesterday
            if (this.users[i].licenses[0].validuntil >= yesterdaystart && this.users[i].licenses[0].validuntil <= yesterdayend) {
              this.expyesterday++
              if (this.users[i].cellnumber != null) {
                if (this.users[i].cellnumber.substring(0, 4) == "+372") {this.estexpyesterday++; this.expsumyest++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+371") {this.ltvexpyesterday++; this.expsumyest++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+370") {this.litexpyesterday++; this.expsumyest++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+358") {this.finexpyesterday++; this.expsumyest++;}
              }
            }
            //Expired licenses this week
            if (this.users[i].licenses[0].validuntil >= weekdaystart && this.users[i].licenses[0].validuntil <= dayend) {
              this.expweek++
              if (this.users[i].cellnumber != null) {
                if (this.users[i].cellnumber.substring(0, 4) == "+372") {this.estexpweek++; this.expsumweek++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+371") {this.ltvexpweek++; this.expsumweek++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+370") {this.litexpweek++; this.expsumweek++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+358") {this.finexpweek++; this.expsumweek++;}
              }
            }
            //Expired licenses this month
            if (this.users[i].licenses[0].validuntil >= monthdaystart && this.users[i].licenses[0].validuntil <= dayend) {
              this.expmonth++
              if (this.users[i].cellnumber != null) {
                if (this.users[i].cellnumber.substring(0, 4) == "+372") {this.estexpmonth++; this.expsummonth++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+371") {this.ltvexpmonth++; this.expsummonth++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+370") {this.litexpmonth++; this.expsummonth++;}
                else if (this.users[i].cellnumber.substring(0, 4) == "+358") {this.finexpmonth++; this.expsummonth++;}
              }
            }
          }
          //Groups joined today
          if (this.users[i].last_joined >= daystart && this.users[i].last_joined <= dayend) {
            this.gtoday++
            if (this.users[i].cellnumber != null) {
              if (this.users[i].cellnumber.substring(0, 4) == "+372") {this.estgtoday++; this.gsumtoday++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+371") {this.ltvgtoday++; this.gsumtoday++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+370") {this.litgtoday++; this.gsumtoday++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+358") {this.fingtoday++; this.gsumtoday++;}
            }
          }
          //Groups joined yesterday
          if (this.users[i].last_joined >= yesterdaystart && this.users[i].last_joined <= yesterdayend) {
            this.gyesterday++
            if (this.users[i].cellnumber != null) {
              if (this.users[i].cellnumber.substring(0, 4) == "+372") {this.estgyesterday++; this.gsumyest++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+371") {this.ltvgyesterday++; this.gsumyest++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+370") {this.litgyesterday++; this.gsumyest++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+358") {this.fingyesterday++; this.gsumyest++;}
            }
          }
          //Groups joined this week
          if (this.users[i].last_joined >= weekdaystart && this.users[i].last_joined <= dayend) {
            this.gweek++
            if (this.users[i].cellnumber != null) {
              if (this.users[i].cellnumber.substring(0, 4) == "+372") {this.estgweek++; this.gsumweek++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+371") {this.ltvgweek++; this.gsumweek++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+370") {this.litgweek++; this.gsumweek++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+358") {this.fingweek++; this.gsumweek++;}
            }
          }
          //Groups joined this month
          if (this.users[i].last_joined >= monthdaystart && this.users[i].last_joined <= dayend) {
            this.gmonth++
            if (this.users[i].cellnumber != null) {
              if (this.users[i].cellnumber.substring(0, 4) == "+372") {this.estgmonth++; this.gsummonth++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+371") {this.ltvgmonth++; this.gsummonth++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+370") {this.litgmonth++; this.gsummonth++;}
              else if (this.users[i].cellnumber.substring(0, 4) == "+358") {this.fingmonth++; this.gsummonth++;}
            }
          }
        }
        this.last_updated = localStorage.getItem('last_updated')
        this.loaded = true
        this.refreshingData = false
        if(this.loaded) this.saveData()
        let simsAPI = API_ENDPOINTS.TIW_API + "/sim/all"
        axios.get(simsAPI).then((res) => {
          this.sims = this.normalizeArray(res.data)
        })
        let teamsAPI = API_ENDPOINTS.TIW_API + "/team/list_all"
        axios.get(teamsAPI).then((data) => {
          this.team = this.prepareTeams(data.data)
        })
        this.searchesModal()
        this.searchesModal()
      }
      else setTimeout(() => {  this.getData()  }, 10000)
    },
    //POST REQUESTS_________________________________________________________________________________________
    addNotes(user) {
      let note = document.getElementById("userNoteInput")
      if (note.value != "") {
        let body = {
          name: "admin_note",
          created: Date.now(),
          data: { text: note.value },
          dataJsonStr: null,
        }
        let apiURL = API_ENDPOINTS.TIW_API + "/activity/" + user.cellnumber
        axios.post(apiURL, body).then((res) => {
          alert("Note has been added")
          document.getElementById("userNoteInput").value = ""
          user.notes.push(body)

        })
      }
    },
    submitSingleLicense(user) {
      let now = Date.now()
      let email = firebase.auth().currentUser.email
      let name = email.split('@')[0].split('.')[0]
      name = name.charAt(0).toUpperCase() + name.slice(1)
      let comment = document.getElementById("newLicenseComment")
      let time = new Date(this.userLicenseDate)
      let body = {
        created : now,
        creator : name,
        comment : comment.value,
        valid : true,
        validUntil : time.getTime(),
        phoneNumber : user.cellnumber
      }
      let backendAPI = API_ENDPOINTS.TIW_API + "/rest/lic"
      axios.post(backendAPI, body).then((res) => {
        body.validuntil = body.validUntil
        user.licenses.push(body)
        alert("License added to "+user.cellnumber+" until "+this.userLicenseDate)
        this.togglenewlicense = !this.togglenewlicense
      })
    },
    toPortal() {
      let url = API_ENDPOINTS.PORTAL_API
      const a = document.createElement("a")
      a.setAttribute("hidden", "")
      a.setAttribute("href", url)
      a.setAttribute("target", "_blank")
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    //TOGGLES_____________________________________________________________________________________
    toggleDevices() {
      this.toggledevices = !this.toggledevices
    },
    toggleLicenses() {
      this.togglelicenses = !this.togglelicenses
    },
    toggleNotes() {
      this.togglenotes = !this.togglenotes
    },
    toggleUserLicense() {
      this.togglenewlicense = !this.togglenewlicense
      let def = Date.now() + 31556952000
      let y = new Date(def).getFullYear()
      let m = ("0" + (new Date(def).getMonth() + 1)).slice(-2)
      let d = ("0" + (new Date(def).getDate())).slice(-2)
      this.userLicenseDate = y+"-"+m+"-"+d
    },
    normalizeArray(value) {
      return Array.isArray(value) ? value.filter((item) => item != null) : []
    },
    prepareTeams(teams) {
      return this.normalizeArray(teams).map((team) => {
        let permissions = this.normalizeArray(team.permissions)
        let preparedTeam = {
          ...team,
          permissions,
          phoneNumber: "",
          ownerName: "",
          teamName: team.name || "",
        }

        for (let j = 0; j < permissions.length; j++) {
          if (permissions[j].permission == "owner" && permissions[j].user) {
            preparedTeam.phoneNumber = permissions[j].user.phoneNumber
            preparedTeam.ownerName = permissions[j].user.name
            break
          }
        }

        return preparedTeam
      })
    },
    searchCollection(collection, query) {
      let items = this.normalizeArray(collection)
      return query ? $.array.search(items, query) : items
    },
    //MODAL TRIGGERS______________________________________________________________________________
    searchFor() {
      if(this.searchInput.length > 0){
        this.loadingSearch = true
        setTimeout(() => {this.searchesModal()}, 1000)
      }
    },
    searchesModal(){
      if(this.tempInput != "" && this.searchInput == "") this.searchInput = this.tempInput
      this.searchUsers = this.searchCollection(this.users, this.searchInput)
      this.searchSims = this.searchCollection(this.sims, this.searchInput)
      this.TogglePopup("searchesButtonTrigger")
      this.loadingSearch = false
      if(this.refreshingData) this.tempInput = this.searchInput
      this.searchInput = ""
    },
    usersModal(user) {
      this.user = user
      let apiURL = API_ENDPOINTS.TIW_API + "/activity/" + user.cellnumber
      axios.get(apiURL).then((res) => {
        this.user.notes = res.data
        this.user.teamsinfo = []
        this.teamsinfo = []
          for(let i = 0; i < this.team.length; i++){
            for(let j = 0; j < this.team[i].permissions.length; j++){
              if(this.user.cellnumber == this.team[i].permissions[j].user.phoneNumber){
                let teamname = this.team[i].teamName
                let role = this.team[i].permissions[j].permission
                let name = this.team[i].ownerName
                let number = this.team[i].phoneNumber
                this.teamsinfo.push({
                  teamName: teamname,
                  teamRole: role,
                  teamOwner: name,
                  teamOwnerNumber: number
              })
              }
            }
          }
          this.user.teamsinfo = this.teamsinfo
          this.TogglePopup("usersButtonTrigger")
      })
    },
    simsModal(sim) {
      this.sim = sim
      this.TogglePopup("simsButtonTrigger")
    },
    //OTHER_____________________________________________________________________________________
    async loginPortal(user) {
      const pin = String(this.portalPIN || "").trim()
      const cell = String(user?.cellnumber || "").trim()

      if (!pin) {
        alert("Please enter PIN.")
        return
      }

      if (!cell) {
        alert("User phone number is missing.")
        return
      }

      const apiURL = API_ENDPOINTS.TIW_API + "/portal-auth/" + encodeURIComponent(cell) + "/" + encodeURIComponent(pin)
      try {
        await axios.get(apiURL)
        alert("User signed in")
        this.portalPIN = ""
      } catch (error) {
        const message = error?.response?.data?.message || error?.response?.data?.error || "Portal login failed."
        alert(message)
      }
    },
  }
};
</script>

<style scoped>
.alignright {
  text-align: right;
  margin-right: 1px;
  width: 15%;
}
th,
td,
tr,
body,
select,
input,
button {
  font-size: 10px;
}
.analytics-view { padding: 4px 18px 18px; color: #202629; }
.analytics-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin: 0 -18px 18px; padding: 20px 22px; border-left: 4px solid #f56600; border-radius: 0 0 9px 9px; background: #202629; color: #fff; }
.analytics-header h1 { margin: 0; font-size: 22px; font-weight: 700; }
.analytics-header-updated { display: flex; align-items: center; gap: 6px; color: #c8d0d3; font-size: 11px; font-style: italic; }
.analytics-header-loading { display: inline-flex; }
.analytics-header-loading .spinner-border { width: 11px; height: 11px; border-width: 2px; }
.analytics-filters-card { margin-bottom: 12px; padding: 12px; border: 1px solid #e1e5e6; border-radius: 9px; background: #fbfcfc; }
.analytics-filter-row, .analytics-columns-row { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 12px; }
.analytics-columns-row { margin-top: 10px; padding-top: 10px; border-top: 1px solid #e1e5e6; }
.analytics-filter-label { color: #40545e; font-weight: 700; text-transform: uppercase; }
.analytics-filter-select { width: 160px; }
.analytics-date-filter { width: 150px; }
.analytics-filter-select:focus, .analytics-date-filter:focus { border-color: #f56600; box-shadow: 0 0 0 .15rem rgba(245, 102, 0, .16); }
.analytics-table-wrap { overflow-x: auto; border: 1px solid #e1e5e6; border-radius: 9px; background: #fff; }
.analytics-table { min-width: 850px; margin-bottom: 0; }
.analytics-table thead { background: #f1f4f5; }
.analytics-table th, .analytics-table td { padding: 9px 10px; vertical-align: middle; border-color: #e1e5e6; }
.analytics-table thead th { color: #40545e; font-size: 10px; font-weight: 700; letter-spacing: .03em; text-transform: uppercase; }
.analytics-table tbody tr:last-child > * { border-bottom: 0; }
@media (max-width: 700px) { .analytics-view { padding: 4px 10px 12px; } .analytics-header { margin: 0 -10px 14px; padding: 16px; } .analytics-filter-select, .analytics-date-filter { width: 100%; } }
.analytics-filter-label,
.analytics-filter-select {
  font-size: 10px;
}
.analytics-filter-select {
  width: 160px;
}
.analytics-date-filter {
  width: 150px;
}
.analytics-column-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
}
.analytics-header-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.analytics-info-icon {
  display: inline-flex;
  align-items: center;
  color: #6c757d;
  cursor: help;
}
.analytics-sort-button {
  border: 0;
  background: transparent;
  padding: 0;
  font-size: 10px;
  font-weight: 700;
  color: inherit;
  text-align: left;
}
.analytics-sort-button:hover {
  text-decoration: underline;
}
.analytics-row-total td {
  font-weight: 700;
}
.home-search-results { padding: 0; color: #202629; }
.home-search-results-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin: -20px -20px 18px; padding: 20px 24px; color: #fff; background: #202629; border-left: 5px solid #ff6b00; border-radius: 10px 10px 0 0; }
.home-search-results-header span { display: block; color: #ff6b00; font-size: 10px; font-weight: 800; letter-spacing: .08em; }
.home-search-results-header h1 { margin: 5px 0 0; font-size: 22px; font-weight: 750; }
.home-search-results-refresh { display: inline-flex; align-items: center; gap: 7px; color: #d7e1e6; font-size: 11px; }
.home-search-results-refresh .spinner-border { width: 13px; height: 13px; border-width: 2px; }
.home-search-results-section { margin: 0 0 16px; padding: 14px; border: 1px solid #d9e0e3; border-radius: 10px; background: #fbfcfc; }
.home-search-results-heading h2 { margin: 0 0 10px; color: #202629; font-size: 15px; font-weight: 750; }
.home-search-results-heading h2 span { color: #647078; font-weight: 500; }
.home-search-results-empty { padding: 8px 0; color: #68747c; font-size: 13px; }
.home-search-results-table-wrap { overflow-x: auto; border: 1px solid #d9e0e3; border-radius: 8px; background: #fff; }
.home-search-results-table { min-width: 1050px; margin: 0; font-size: 11px; }
.home-search-results-table thead th { padding: 10px 12px; color: #50616c; background: #fff; border-top: 0; border-bottom: 1px solid #aebbc1; font-size: 10px; font-weight: 800; letter-spacing: .035em; text-transform: uppercase; white-space: nowrap; }
.home-search-results-table tbody td { padding: 10px 12px; border-color: #dce4e7; vertical-align: middle; white-space: nowrap; }
.home-search-results-table tbody tr:last-child td { border-bottom: 0; }
.home-search-results-details { padding: 4px 10px; color: #202629; border: 1px solid #71838d; background: #fff; font-size: 10px; }
.home-search-results-details:hover { color: #fff; border-color: #ff6b00; background: #ff6b00; }
@media (max-width: 700px) { .home-search-results-header { margin: -16px -16px 14px; padding: 16px; } .home-search-results-section { padding: 10px; } }

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
.lds-ring-sm {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
}
.lds-ring-sm div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 24px;
  height: 24px;
  border: 4px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring-sm div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring-sm div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring-sm div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .home {
    max-width: 90%;
  }
}
</style>
